var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"release",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.onSelect(_vm.url)}}},[_c('div',{staticClass:"iconfont iconbianji border-color font-color"}),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }